import { useDisplayLabel } from '@ps/web-shared-components';
import React from 'react';
import type { FieldInputProps, FieldMetaState } from 'react-final-form';

import type { Props as InputProps } from '../../Input';
import { Validation } from '../../Input';
import InputValidationMessages from '../InputValidationMessages/InputValidationMessages';

import { inlineValidationError } from './ErrorMessage.scss';

export interface Props {
  input?: FieldInputProps<InputProps['value'], HTMLElement>;
  meta?: FieldMetaState<string>;
  validationVariant: InputProps['validationVariant'];
  validationErrors: InputProps['validationErrors'];
  hideError: boolean;
}

const ErrorMessage: React.FC<Props> = ({
  meta,
  input,
  hideError,
  validationVariant,
  validationErrors
}) => {
  const displayLabel = useDisplayLabel(meta?.error?.message);

  if (hideError || !meta || !input) {
    return null;
  }
  if (meta.submitError && !meta.dirtySinceLastSubmit) {
    return <p>{meta.submitError}</p>;
  }

  if (
    (validationVariant === Validation.List && meta.dirty) ||
    validationVariant === Validation.ImmediateList
  ) {
    return (
      <InputValidationMessages validations={validationErrors} input={input} dirty={!!meta.dirty} />
    );
  }

  const inlineValidationHasError = validationVariant === Validation.Inline && meta.touched;
  const immediateInlineValidationHasError =
    validationVariant === Validation.ImmediateInline &&
    meta.visited &&
    (!meta.pristine || meta.touched);

  if (
    (inlineValidationHasError || immediateInlineValidationHasError) &&
    meta.invalid &&
    meta.error &&
    meta.error.message
  ) {
    return <p className={inlineValidationError}>{displayLabel}</p>;
  }

  return null;
};

export default ErrorMessage;
